<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
                        Agent Bank Info
                    </div>
                    <div class="card-body">
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th>Agent Name</th>
                                        <th>Payment Method</th>
                                        <th>Account Name</th>
                                        <th>Account Number</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.master_agent.name }}</td>
                                        <td>{{ data.payment_method.name }}</td>
                                        <td>{{ data.name }}</td>
                                        <td>{{ data.account_number }}</td>
                                        <td>
                                            <button v-b-modal.bv-modal-updateBank class="btn btn-option text-primary" @click="editData(data)"><i class="fas fa-edit"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <b-modal id="bv-modal-bank" ref="my-modal" title="New Bank Info" hide-footer>
                            <div class="form-group">
                                <label for="status">Payment Method</label>
                                <select v-model="bankRequest.payment_method_id" @blur="validationRule()" class="form-control" id="bankSelect">
                                    <option value="">Select Payment Method</option>
                                    <option v-for="bank in paymentMethod" :key="bank.id" :value="bank.id">{{ bank.name }}</option>
                                </select>
                                <small class="text-danger">{{validationData.payment_method_id}}</small>
                            </div>
                            <div class="form-group">
                                <label for="inputUserName">Account Name</label>
                                <input type="text" v-model="bankRequest.name" @blur="validationRule()" class="form-control" id="inputName">
								<small class="text-danger">{{validationData.name}}</small>
                            </div>
                            <div class="form-group">
                                <label for="inputUserName">Account Number</label>
                                <input type="text" v-model="bankRequest.account_number" @blur="validationRule()" class="form-control" id="inputAccountNumber">
								<small class="text-danger">{{validationData.account_number}}</small>
                            </div>
                            <b-button class="mt-3 btn-success" block @click="addBankInfo()">Submit</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-updateBank" ref="my-modal" title="Edit Bank Info" hide-footer>
                            <div class="form-group">
                                <label for="status">Payment Method</label>
                                <select v-model="bankRequest.payment_method_id" @blur="validationRule()" class="form-control" id="bankSelect">
                                    <option value="">Select Payment Method</option>
                                    <option v-for="bank in paymentMethod" :key="bank.id" :value="bank.id">{{ bank.name }}</option>
                                </select>
                                <small class="text-danger">{{validationData.payment_method_id}}</small>
                            </div>
                            <div class="form-group">
                                <label for="inputUserName">Account Name</label>
                                <input type="text" v-model="bankRequest.name" @blur="validationRule()" class="form-control" id="inputName">
								<small class="text-danger">{{validationData.name}}</small>
                            </div>
                            <div class="form-group">
                                <label for="inputUserName">Account Number</label>
                                <input type="text" v-model="bankRequest.account_number" @blur="validationRule()" class="form-control" id="inputAccountNumber">
								<small class="text-danger">{{validationData.account_number}}</small>
                            </div>
                            <b-button class="mt-3 btn-success" block @click="updateBankInfo()">Submit</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <a class="float" v-b-modal.bv-modal-bank>
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </a>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'agentBankInfo',
        metaInfo: {
            title: "Agent Bank Info",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                agentId: '',
                dataList: [],
                paymentMethod: [],
                bankRequest: {
                    id: "",
					name: "",
					account_number: "",
					payment_method_id: "",
				},
                columns: {
                    code: "Code",
                    name: "Name",
                    phone: "Phone",
                    email: "Email",
                    created_at: "Created At"
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    name: "",
                    phone: "",
                    code: ""
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                },
                validationData: {
					name: "",
					account_number: "",
					payment_method_id: ""
				}
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                agentBankListAction: 'agentBankListAction',
                paymentMethodAction: 'paymentMethodAction',
                agentBankStoreAction: 'agentBankStoreAction',
                agentBankUpdateAction: 'agentBankUpdateAction',
                agentDeleteAction: 'agentDeleteAction',
            }),
            async getPaymentMethod(){
				await this.paymentMethodAction().then(res => {
					this.paymentMethod = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                console.log(this.agentId)
                let option = {
                    'agent_id': this.agentId,
                }
                await this.agentBankListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data
                        // this.metaData.last_page = res.data.meta.lastPage
                        // this.metaData.current_page = res.data.meta.currentPage
                        // this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        // this.metaData.from = res.data.meta.from
                        // this.metaData.to = res.data.meta.to
                        // this.metaData.total = res.data.meta.total
                        // this.$router.replace({ 
                        //     path: 'agent-bank-info', 
                        //     query: { 
                        //         page: this.filter.page, 
                        //         orderBy: this.filter.orderBy, 
                        //         sortKey: this.filter.sortKey,
                        //         name: this.filter.name,
                        //         phone: this.filter.phone,
                        //         code: this.filter.code,
                        //         id: this.agentId
                        //     } 
                        // }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            async addBankInfo() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
                formData.append('agent_id', this.agentId);
				formData.append('name', this.bankRequest.name);
				formData.append('account_number', this.bankRequest.account_number);
				formData.append('payment_method_id', this.bankRequest.payment_method_id);

				await this.agentBankStoreAction(
					formData
				).then(res => {
					if(res.success == false){
							this.alert = res.message
                    }else{
                        this.bankRequest.name = ""
                        this.bankRequest.account_number = ""
                        this.bankRequest.payment_method_id = ""
                        this.alert = ""
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            async updateBankInfo() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
                formData.append('id', this.bankRequest.id);
				formData.append('name', this.bankRequest.name);
				formData.append('account_number', this.bankRequest.account_number);
				formData.append('payment_method_id', this.bankRequest.payment_method_id);

				await this.agentBankUpdateAction(
					formData
				).then(res => {
					if(res.success == false){
							this.alert = res.message
                    }else{
                        this.bankRequest.name = ""
                        this.bankRequest.account_number = ""
                        this.bankRequest.payment_method_id = ""
                        this.alert = ""
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            back() {
				this.$router.replace({ 
					path: 'agent-list', 
					query: { 
						page: this.filter.page, 
						orderBy: this.filter.orderBy, 
						sortKey: this.filter.sortKey, 
						name: this.filter.name,
						phone: this.filter.phone,
						code: this.filter.code
					} 
				}).catch(()=>{})
			},
            editData(data){
                this.bankRequest.id = data.id
                this.bankRequest.name = data.name
                this.bankRequest.account_number = data.account_number
                this.bankRequest.payment_method_id = data.payment_method_id
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.agentDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            validationRule() {
				let isValidation = []
				if (this.bankRequest.payment_method_id == "") {
					this.validationData.payment_method_id = "The payment method field is required."
					isValidation.push(true)
				} else {
					this.validationData.payment_method_id = ""
					isValidation.push(false)
				}
				if (this.bankRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.bankRequest.account_number == "") {
					this.validationData.account_number = "The account number field is required."
					isValidation.push(true)
				} else {
					this.validationData.account_number = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.agentId = this.$route.query.id
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.name = this.$route.query.name
            this.filter.phone = this.$route.query.phone
            this.filter.code = this.$route.query.code

            console.log(this.filter)
            this.fetchData()
            this.getPaymentMethod()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>